export default __webpack_public_path__ + "static/media/stop-recording.380c3cef.svg";